var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pb-3"},[_c('div',{staticClass:"v-card__title greytxt--text pa-0"},[_c('h5',[_vm._v(_vm._s(_vm.field.label))])]),_c('codemirror',{attrs:{"options":_vm.cmOptions},model:{value:(_vm.newValue),callback:function ($$v) {_vm.newValue=$$v},expression:"newValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }